<template>
	<div v-loading.fullscreen.lock="isLoading"></div>
	<main v-if="!isAuthenticating && !!user">
		<el-container class="d-flex">
			<el-header height="60px"><top-bar /></el-header>
			<el-container style="height: calc(100vh - 60px)">
				<el-aside class="hidden-md-and-down" v-if="user.type !== 'siswa'">
					<el-scrollbar><app-menu /></el-scrollbar>
				</el-aside>
				<el-main class="p-0">
					<div ref="mainContent">
						<div class="bg-image"></div>
						<el-scrollbar>
							<div class="container-fluid p-4">
								<page-header v-if="$route.name !== 'forbidden' && $route.name !== 'not-found'" />
								<router-view @layout-updated="updateBgPosition" v-slot="{ Component }">
									<transition name="slide-up" mode="out-in">
										<component :is="Component" />
									</transition>
								</router-view>
							</div>
						</el-scrollbar>
					</div>
				</el-main>
			</el-container>
		</el-container>
	</main>
</template>

<script>
import WebSocketManager from "./services/WebSocketManager";
import AppMenu from "./components/AppMenu.vue";
import PageHeader from "./components/PageHeader.vue";
import TopBar from "./components/TopBar.vue";

export default {
	name: "App",
	data() {
		return {
			updatedProfile: async (data) => {
				const d = JSON.parse(data);
				if (d.user_id === this.user.user_id) {
					await this.$store.dispatch("verifyToken");
				}
			},
			updatedPassword: async (data) => {
				const d = JSON.parse(data);
				if (d.user_id === this.user.user_id) {
					await this.$store.dispatch("logoutUser");
				}
			},
		};
	},
	components: {
		TopBar,
		AppMenu,
		PageHeader,
	},
	computed: {
		isAuthenticating() {
			return this.$store.getters.isAuthenticating;
		},
		isLoading() {
			return this.$store.getters.isLoading;
		},
		user() {
			return this.$store.getters.getUser;
		},
	},
	watch: {},
	created() {
		if (this.user?.type !== "siswa") this.$store.dispatch("rombel/fetchList");
	},
	mounted() {
		this.$ws.main = WebSocketManager.connect(process.env.VUE_APP_SOCKET_NAMESPACE, process.env.VUE_APP_SOCKET_PATH);
		this.$ws.auth = WebSocketManager.connect(process.env.VUE_APP_AUTH_SOCKET_NAMESPACE, process.env.VUE_APP_AUTH_SOCKET_PATH);
		this.$ws.auth.on("user:updated", this.updatedProfile);
		this.$ws.auth.on("user:updated-password", this.updatedPassword);
		this.updateBgPosition();
		window.addEventListener("resize", this.updateBgPosition);
	},
	beforeUnmount() {
		this.$ws.auth.off("user:updated");
		this.$ws.auth.off("user:updated-password");
		this.$ws.main.disconnect();
		this.$ws.auth.disconnect();
		window.removeEventListener("resize", this.updateBgPosition);
	},
	methods: {
		updateBgPosition() {
			this.$nextTick(() => {
				const el = this.$refs.mainContent;
				const bg = el?.querySelector(".bg-image");
				const nf = el?.querySelector(".not-found");
				if (el && bg) {
					const rect = el.getBoundingClientRect();
					bg.style.left = `${rect.left}px`;
					bg.style.width = `${rect.width}px`;
					if (nf) {
						nf.style.left = `${rect.left}px`;
						nf.style.width = `${rect.width}px`;
					}
				}
			});
		},
	},
};
</script>
<style>
#app {
	font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande", "Lucida Sans", Arial, sans-serif;
}
.bg-image {
	position: fixed;
	top: 60px;
	height: calc(100vh - 60px);
	z-index: -1;
	background-color: #dae7f1;
	background-image: url("./assets/logo.png");
	background-size: auto;
	background-position: center;
	background-attachment: local;
	background-repeat: no-repeat;
	filter: blur(5px) opacity(0.7);
}
.el-loading-mask {
	background-color: rgba(180, 200, 240, 0.25) !important;
}
aside {
	background-color: #f7f9ff !important;
	box-shadow: 0 0 16px 0 rgba(23, 58, 101, 0.25);
}
.card,
.offcanvas-xl.offcanvas-start {
	background-color: #f7f9ff !important;
	box-shadow: 0 0 16px 4px rgba(23, 58, 101, 0.25);
}
.el-upload.el-upload--picture-card {
	width: fit-content !important;
	height: fit-content;
	border: none;
}
.offcanvas-xl.offcanvas-start {
	max-width: 320px;
}
.el-menu-item,
.el-sub-menu__title {
	height: 42px !important;
	border-radius: 0 21px 21px 0;
	transition: all 0.25s ease;
	margin-bottom: 4px;
}
.el-sub-menu .el-menu-item {
	margin-bottom: 2px;
	padding-left: 49px !important;
}
.el-menu-item a.el-link {
	color: inherit;
	transition: color 0.25s ease;
}
.el-menu-item.is-active a.el-link {
	color: #fff !important;
}
.el-menu-item.is-active {
	color: #fff !important;
	background: linear-gradient(135deg, #3763ac, #152746) !important;
}
.el-menu-item:hover,
.el-sub-menu__title:hover,
.el-sub-menu.is-active > .el-sub-menu__title:hover {
	background: linear-gradient(135deg, #4575c0, #1c3459) !important;
	color: #fff !important;
}
.el-sub-menu.is-active > .el-sub-menu__title {
	background: linear-gradient(135deg, #5b8fe0, #264a7c) !important;
	color: #fff !important;
}

div.el-pagination > button:disabled {
	background-color: transparent !important;
}

.slide-right-enter-active,
.slide-right-leave-active {
	transition: all 0.3s ease-in-out;
}
.slide-right-enter-from {
	opacity: 0;
	transform: translateX(-20px);
}
.slide-right-leave-to {
	opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
	transition: all 0.3s ease-in-out;
}
.slide-up-enter-from {
	opacity: 0;
	transform: translateY(20px);
}
.slide-up-leave-to {
	opacity: 0;
	transform: translateY(-20px);
}

.fade-enter-active,
.fade-leave-active {
	transition: all 0.3s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.highlighted {
	animation: pulse 0.6s ease-in-out;
}
@keyframes pulse {
	0% {
		background-color: #f7f9ff;
	}
	50% {
		background-color: #dae7f1;
	}
	100% {
		background-color: transparent;
	}
}
</style>
